@if (viewModel(); as vm) {
  @if (vm.allSalesFunnelsDisabled === true) {
    @if (computedContent()?.useAccessibleCalculator) {
      <crnt-callout variant="negative">
        {{ vm.allSalesFunnelsDisabledMessageText }}
        <span slot="title">{{ vm.allSalesFunnelsDisabledMessageTitle }}</span>
        <a
          [href]="vm.allSalesFunnelsDisabledMessageLink?.href"
          slot="actions"
          >{{ vm.allSalesFunnelsDisabledMessageLink?.text }}</a
        >
      </crnt-callout>
    } @else {
      <wl-info-card
        [title]="vm.allSalesFunnelsDisabledMessageTitle"
        [message]="vm.allSalesFunnelsDisabledMessageText"
        [buttonLink]="vm.allSalesFunnelsDisabledMessageLink"
        type="warning"
      ></wl-info-card>
    }
  } @else {
    <wl-calculate-form
      id="calculate-form"
      [rendering]="rendering()"
      [content]="computedContent()"
      [formState]="vm.formState"
      [installationAddressStatus]="vm.installationAddressStatus"
      [installationAddressNotFound]="vm.installationAddressNotFound"
      [houseNumberExtensions]="vm.houseNumberExtensions"
      [installationAddresses]="vm.installationAddresses"
      [showManualHouseNumberAdditionInput]="vm.houseNumberAdditionInputEnabled"
      [showSpinnerWhenSubmitButtonDisabled]="
        vm.showSpinnerWhenSubmitButtonDisabled
      "
      [submitButtonDisabled]="vm.isSubmitButtonDisabled"
      [isInModal]="isInModal()"
      [useAccessibleCalculator]="computedContent()?.useAccessibleCalculator"
      (submitCalculate)="submit()"
      (openModal)="openModal($event)"
      (hideHouseNumberInput)="hideManualHouseNumberInput()"
      (submitAlternateAddress)="submitAlternateAddress()"
    ></wl-calculate-form>
  }
}
